
export default {
  auth: false,
  // validate url
  validate ({ params, nuxt }) {
    return /^[0-9A-Fa-f-]{36}$/.test(params.tenderID);
  },

  async asyncData ({ $axios, route, $auth, $user, error }) {
    try {
      if ($auth.loggedIn && $user.team) {
        const tender = await $axios.$get(`/tender/${route.params.tenderID}`);

        return { tender: { ...tender, preview: false } };
      } else {
        return {
          tender: {
            ...(await $axios.$get(
              `/tender/${route.params.tenderID}/preview`
            )),
            status: 'Active',
            preview: true
          }
        };
      }
    } catch (e) {
      console.error(e);
      // show error page if tender isn't found
      error({ statusCode: 404, message: 'Deze aanbesteding bestaat niet.' });
    }
  },

  head () {
    if (this.tender.preview) {
      return {
        title: this.tender.title,
        link: [
          {
            rel: 'alternate',
            type: 'application/json+oembed',
            href: `${this.$config.frontendURL}/services/oembed?url=${encodeURI(`${this.$config.frontendURL}/tender/${this.tender.id}`)}`,
            title: `Aanbesteding van ${this.tender.organizationNames.join(', ')}`
          }
        ],
        meta: [
          {
            property: 'og:image',
            content: `${this.$config.frontendURL}/tender/${this.tender.id}.png`
          },
          {
            property: 'twitter:image',
            content: `${this.$config.frontendURL}/tender/${this.tender.id}.png`
          },
          {
            name: 'title',
            content: 'Altura | ' + this.tender.title
          },
          {
            property: 'og:title',
            content: 'Altura | ' + this.tender.title
          },
          {
            hid: 'description',
            name: 'description',
            content: this.tender.description
          },
          {
            property: 'og:description',
            content: this.tender.description
          },
          {
            property: 'twitter:description',
            content: this.tender.description
          },
          {
            property: 'og:url',
            content: `${this.$config.frontendURL}/tender/${this.tender.id}`
          },
          {
            property: 'og:type',
            content: 'website'
          },
          {
            name: 'author',
            content: this.tender.organizationNames.join()
          },
          {
            name: 'twitter:card',
            content: 'summary_large_image'
          }
        ],
        script: [
          {
            type: 'application/ld+json',
            json: {
              '@context': 'https://schema.org',
              '@type': 'ItemList',
              itemListElement: [{
                type: 'application/ld+json',
                json: {
                  '@context': 'https://schema.org',
                  '@type': 'BreadcrumbList',
                  itemListElement: [
                    {
                      '@type': 'ListItem',
                      position: 1,
                      name: 'Aanbestedingen',
                      url: this.$config.frontendURL + '/tender/'
                    },
                    {
                      '@type': 'ListItem',
                      position: 2,
                      name: this.tender.title,
                      url: this.$config.frontendURL + '/tender/' + this.tender.id
                    }
                  ]
                }
              }]
            }

          }
        ]
      };
    }

    return {
      title: this.tender.tenderVersions[0].title,
      link: [
        {
          rel: 'alternate',
          type: 'application/json+oembed',
          href: `${this.$config.frontendURL}/services/oembed?url=${encodeURI(`${this.$config.frontendURL}/tender/${this.tender.id}`)}`
        }
      ],
      meta: [
        {
          name: 'title',
          content: this.tender.tenderVersions[0].title
        },
        {
          property: 'og:title',
          content: 'Altura | ' + this.tender.tenderVersions[0].title
        },
        {
          property: 'og:url',
          content: `${this.$config.frontendURL}/tender/${this.tender.id}`
        },
        {
          property: 'og:type',
          content: 'website'
        }
      ]
    };
  },

  computed: {
    previewPrice () {
      if (this.tender.price < 10) { return 'Onbekend'; }

      const formattedPrice = this.$options.filters.formatPrice(this.tender.price);

      if (this.tender.price < 500) { return `€${formattedPrice} per uur`; }

      return `€${formattedPrice}`;
    }
  },

  watch: {
    '$user.team' () {
      if (this.$user.team) {
        this.$nuxt.refresh();
      }
    }
  }
};
